module.exports = __webpack_public_path__ + "static/media/iconindustry.f84179be.svg";